<script>
	export let value = "";
	export let maxlength = 1000;
	export let error = false;
	export let errorText = "";
	export let placeholder = "";
	export let id = "";
	export let onInput = () => {};
	export let wordCount = true;
	export let label = "";
</script>

<div>
	<textarea
		{placeholder}
		bind:value
		{maxlength}
		class={`form-control getgo input textarea ${error ? "danger" : ""}`}
		id={id || undefined}
		aria-label={label || placeholder || id}
		rows="3"
		on:input={onInput}
	/>
	{#if wordCount}
		<p class="d-flex justify-content-end word-count">
			{value.length + `/` + maxlength} characters
		</p>
	{/if}
	{#if error}
		<small class="error-text">{errorText}</small>
	{/if}
</div>

<style>
	.textarea {
		width: 100%;
		height: 140px !important;
	}

	.word-count {
		color: var(--fds-on-surface-variant);
		font-size: 12px;
	}
</style>
